/* models/widgets/button */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    var abstract_button_1 = require(436) /* ./abstract_button */;
    var bokeh_events_1 = require(3) /* ../../core/bokeh_events */;
    var p = require(18) /* ../../core/properties */;
    var ButtonView = /** @class */ (function (_super) {
        tslib_1.__extends(ButtonView, _super);
        function ButtonView() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ButtonView.prototype.click = function () {
            this.model.clicks = this.model.clicks + 1;
            this.model.trigger_event(new bokeh_events_1.ButtonClick());
            _super.prototype.click.call(this);
        };
        ButtonView.__name__ = "ButtonView";
        return ButtonView;
    }(abstract_button_1.AbstractButtonView));
    exports.ButtonView = ButtonView;
    var Button = /** @class */ (function (_super) {
        tslib_1.__extends(Button, _super);
        function Button(attrs) {
            return _super.call(this, attrs) || this;
        }
        Button.initClass = function () {
            this.prototype.default_view = ButtonView;
            this.define({
                clicks: [p.Number, 0],
            });
            this.override({
                label: "Button",
            });
        };
        Button.__name__ = "Button";
        return Button;
    }(abstract_button_1.AbstractButton));
    exports.Button = Button;
    Button.initClass();
}
